import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Content from '../components/Content';
import Footer from '../components/Footer';
import Main from '../components/Main';
import Wrapper from '../components/Wrapper';
import NavbarLogout from '../components/navbar/NavbarLogout';
import Navbar from '../components/navbar/Navbar';

import ErrorBoundary from './ErrorBoundary';
import { UrlPath } from './../constants';

const Dashboard = ({ children }) => {
  const location = useLocation();

  return (
    <React.Fragment>
      <Wrapper>
        {/* <Sidebar items={allItems} /> */}
        <Main>
          {location.pathname !== UrlPath.logout &&
          location.pathname !== UrlPath.endUserRegistrationSuccess &&
          location.pathname !== UrlPath.invalidRegistrationLink &&
          !location.pathname.includes(
            UrlPath.endUserRegistration.replace(':id', ''),
          ) ? (
            <Navbar />
          ) : (
            <NavbarLogout />
          )}
          <Content>
            <ErrorBoundary>
              {children}
              <Outlet />
            </ErrorBoundary>
          </Content>
          <Footer />
        </Main>
      </Wrapper>
    </React.Fragment>
  );
};

export default Dashboard;
